import { Component,EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarEventModel } from 'src/app/shared/component/weekly-calendar/calendar-event-model';

@Component({
  selector: 'app-calendar-event',
  templateUrl: './calendar-event.component.html',
  styleUrls: ['./calendar-event.component.scss']
})
export class CalendarEventComponent implements OnInit {
  @Input() event : CalendarEventModel;
  @Output() eventSelected = new EventEmitter<CalendarEventModel>();

  get IsMultiDayEvent(): boolean {
    return (new Date(this.event.StartDateTime).toDateString() !== new Date(this.event.EndDateTime).toDateString());
  }

  get EventKeyParts(): { eventId: bigint, recursionEventInstanceNumber: bigint } {
    const shift = BigInt(32);
    const mask = (BigInt(1) << shift) - BigInt(1); // 0xFFFFFFFF

    const eventId = this.event.EventKey >> shift;
    const recursionEventInstanceNumber = this.event.EventKey & mask;

    return { eventId, recursionEventInstanceNumber };
  }

  constructor() { }

  ngOnInit(): void {
  }

  selectEvent(){
    this.event.IsSelected = !this.event.IsSelected;
    this.eventSelected.emit(this.event);
  }
}
